import { IconSvgProps } from '../../../../../components/Icon/Icon';
import BaseLibraryIconSvg from '../../../../../components/Icon/BaseLibraryIconSvg';

export default function ExternalLink(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.363 2.99646C21.609 3.2302 21.6932 3.56701 21.6072 3.85741L21.5194 12.3137C21.5147 12.7699 21.1387 13.1134 20.6797 13.081C20.2207 13.0486 19.8525 12.6526 19.8572 12.1965L19.9241 5.74816L10.2937 15.8701C9.98757 16.1919 9.46213 16.1892 9.12006 15.8642C8.77798 15.5392 8.7488 15.015 9.05488 14.6933L18.8417 4.40694H12.0468C11.5886 4.40694 11.1947 4.03624 11.1669 3.57896C11.1391 3.12168 11.488 2.75098 11.9462 2.75098H20.7281L20.7432 2.75111C20.9618 2.74714 21.1867 2.82901 21.363 2.99646ZM3.3217 7.70139C2.86351 7.70139 2.48824 8.07294 2.48349 8.53127L2.35014 21.4211C2.3454 21.8794 2.71299 22.251 3.17117 22.251H15.9277C16.3859 22.251 16.7612 21.8794 16.7659 21.4211L16.8326 14.9762C16.8374 14.5179 16.4698 14.1463 16.0116 14.1463C15.5534 14.1463 15.1781 14.5179 15.1734 14.9762L15.1153 20.5912H4.01796L4.13414 9.36114H9.68281C10.141 9.36114 10.5163 8.9896 10.521 8.53127C10.5258 8.07294 10.1582 7.70139 9.69998 7.70139H3.3217Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
}
